import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UserView from "./UserView";
import {
    getMeetingById,
    cancelMeeting,
    completeMeeting,
    userDataByUserId
} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    meetingById: state.baMeetingReducer.meetingById,
    cancel: state.baMeetingReducer.cancel,
    complete: state.baMeetingReducer.complete,
    userMeetingDetailsByUserId: state.baMeetingReducer.userMeetingDetailsByUserId

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMeetingById,
            cancelMeeting,
            completeMeeting,
            userDataByUserId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UserView);
